import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import StudentDashboard from "../views/StudentDashboard.vue";
import StudentVideos from "@/views/DashboardContent/StudentVideos.vue";
import StudentProfile from "@/views/DashboardContent/StudentProfile.vue";
import ContactView from "@/views/ContactView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },

  {
    path: "/studentDashboard",
    name: "studentDashboard",
    component: StudentDashboard,
    meta: { requiresAuth: true },
  },

  // {
  //   path: "/studentHome",
  //   name: "studentHome",
  //   component: StudentHome,
  // },

  {
    path: "/studentProfile",
    name: "studentProfile",
    component: StudentProfile,
  },
  {
    path: "/studentVideos",
    name: "studentVideos",
    component: StudentVideos,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Global navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.meta.requiresAuth && !token) {
    // If route requires auth but no token → redirect to "/"
    return next("/");
  }

  next(); // Otherwise, allow navigation
});

export default router;
